   <template>
    <v-app-bar app color="#FF8400" style="width:100%" class="flex-fill d-flex" flat v-resize="onResize">
        <v-card flat class="d-flex flex-fill justify-space-between align-center" style="background-color: #FF8400">
            <v-app-bar-nav-icon v-if="$parent.$parent.isMobile" @click.stop="$parent.$parent.drawer = !$parent.$parent.drawer"></v-app-bar-nav-icon>
            <v-toolbar-title class="justify-center align-center">
            
                <div class="d-flex align-center justify-center  " >
                    <v-img alt="Gobierno"
                        class="mr-2  align-center"
                        contain
                        :src="$renderImageFromAssets('logo_app_bar')"
                        transition="scale-transition"
                        width="100"
                        align=""
                    />
                    <!-- <div class="align-center">
                        {{title}}
                    </div> -->
                </div>

            </v-toolbar-title>

        <!-- <v-spacer></v-spacer> -->
        <!-- <v-badge
            overlap :color="cartStore.numberCartItems > 0 ? 'red': 'transparent'"
            :content="cartStore.numberCartItems"
            class="mr-4"
            v-if="account.loggedIn"
        >
            <router-link :to="{name: 'portfolio', params:{step: 1}}" >
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-img
                                contain
                                :src="$renderImageFromAssets('icon_search')"
                                transition="scale-transition"
                                width="18"
                                v-bind="attrs"
                                v-on="on"
                        >
                        </v-img>
                    </template>
                    <span>Buscar</span>
                </v-tooltip>
            </router-link>
        </v-badge> -->
        <!-- <v-badge
            overlap :color="cartStore.numberCartItems > 0 ? 'red': 'transparent'"
            :content="cartStore.numberCartItems"
            class="mr-4"
            v-if="account.loggedIn"
        >
            <router-link :to="{name: 'portfolio', params:{step: 1}}" >
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-img
                                contain
                                :src="$renderImageFromAssets('icon_notification')"
                                transition="scale-transition"
                                width="18"
                                v-bind="attrs"
                                v-on="on"
                        >
                        </v-img>
                    </template>
                    <span>Notificaciones</span>
                </v-tooltip>
            </router-link>
        </v-badge> -->
        
            <v-card flat tile class="align-center d-flex" style="background-color: #FF8400">

                <router-link class="pt-2" :to="{name: 'portfolio', params:{step: 1}}" >
                    <v-badge
                        bottom
                        overlap :color="cartStore.numberCartItems > 0 ? 'red': 'transparent'"
                        :content="cartStore.numberCartItems"
                        class="mr-4"
                        v-if="account.loggedIn"
                    >
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-img
                                        contain
                                        :src="$renderImageFromAssets('icon_portfolio')"
                                        transition="scale-transition"
                                        width="18"
                                        v-bind="attrs"
                                        v-on="on"
					style="filter: invert(1);"
                                >
                                    <!-- <template><div class="text-subtitle-1 text-center pt-1"><i class="fas fa-shopping-cart"></i></div></template> -->
                                </v-img>
                            </template>
                            <span>Mis Pagos</span>
                        </v-tooltip>
                    </v-badge>
                </router-link>

                <v-menu offset-y elevation="0" :nudge-width="120" transition="scale-transition" v-if="account.loggedIn && account.user != null" id="userOptions">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn text v-bind="attrs" v-on="on" class="px-2 usuario_caja"> 
                            <div class="d-flex flex-column  " style="color: white">
                                <span class="hidden-sm-and-down mr-2 text-family usuario_bienvenida align-self-end">Bienvenido</span>
                                <span class="hidden-sm-and-down  mr-2 text-family usuario_nombre align-self-end" >{{getProfileName()}}</span>
                            </div> 
                            <v-avatar size="32" class="rounded-0 avatar_letra">
                                <v-img v-if="account.user.avatar != 'null' && account.user.avatar != null"  :src="account.user.avatar_path"></v-img>
                                <span  class="text-family text-pantone" v-if="account.user.avatar == 'null' || account.user.avatar == null">{{getProfileLetterName()}}</span>
                            </v-avatar>
                        </v-btn>
                    </template>

                    <v-list class="black--text menu_usuario" style="min-width: 350px;" >
                        <v-row class="center py-5" justify="space-around" style="flex-wrap:nowrap">
                            <v-col md="4">
                                <v-avatar size="100" class="rounded avatar_letra_sub">
                                    <v-img v-if="account.user.avatar != 'null' && account.user.avatar != null"  :src="account.user.avatar_path"></v-img>
                                    <span class="text-pantone" v-if="account.user.avatar == 'null' || account.user.avatar == null">{{getProfileLetterName()}}</span>
                                </v-avatar>
                            </v-col>
                            <v-col md="8">
                                <v-list-item link @click="goToHomeFromBuzon">
                                    <v-list-item-title >Mi buzón</v-list-item-title>
                                </v-list-item>

                                <router-link :to="{name: 'user_profile'}" class="text-decoration-none" v-if="!isGuestCurrentUser()">
                                    <v-list-item link>
                                        <v-list-item-title>Editar perfil</v-list-item-title>
                                    </v-list-item>
                                </router-link>

                                <router-link :to="{name: 'password_update'}" class="text-decoration-none" v-if="!isGuestCurrentUser()">
                                    <v-list-item link>
                                        <v-list-item-title>Cambiar contraseña</v-list-item-title>
                                    </v-list-item >
                                </router-link>

                                <v-list-item @click="doLogout">
                                    <v-list-item-title>Cerrar sesion</v-list-item-title>
                                </v-list-item>
                            </v-col>
                        </v-row>
                    </v-list>
                </v-menu>
            </v-card>

        </v-card>

    </v-app-bar>

</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import router from "../config/router";
import {procedureListRequest} from "bestgob-core/api/models";
export default {
    data() {
        return{
            title: '',
            FILTER_STATUS_ALL: 0
        }
    },
    computed: {
        ...mapState({account: state => state.account, cartStore: state => state.cart, proceduresStore: state => state.procedures})
    },

    props:['clipped-left'],

    mounted() {
        if (this.account.loggedIn)(
            this.getNumberOfItems()
        )

        this.getCurrentPage()
    },

    watch: {
        // eslint-disable-next-line no-unused-vars
        $route(to, from){
            if (this.account.loggedIn && this.cartStore.numberCartItems === 0)(
                this.getNumberOfItems()
            )

            this.getCurrentPage()
        }
    },

    methods: {
        ...mapActions('account', ['logout']),
        ...mapActions('cart', ['getNumberOfItems']),
        ...mapGetters('account', ['isGuestUser']),
        ...mapActions('procedures', ['getProceduresByUser']),

        menuClick(){

        },

        doLogout(){
            this.logout()
        },

        getProfileName(){
            if (this.account.user){
                return `${this.account.user.nombres}`
            }

            return ''
        },

        getProfileLetterName(){
            if (this.account.user){
                var letra = `${this.account.user.nombres}`;
                return letra.substring(0,1);
            }

            return ''
        },

        getCurrentPage(){
            let page = this.$router.currentRoute.name

            if (page === 'home'){
                this.title =  ' - Inicio'
            }

            else if (page === 'processes'){
                this.title =  ' - Procesos'
            }

            else if (page === 'portfolio'){
                this.title =  ' - Portafolio'
            }
        },

        isGuestCurrentUser(){
            return this.isGuestUser()
        },

        goToHomeFromBuzon() {
            router.push({name: 'home'})

            let request = procedureListRequest()
            request.userId = this.account.user.id
            request.status = this.FILTER_STATUS_ALL
            request.limit = this.proceduresStore.pageLimit

            this.getProceduresByUser(request)
        },
        
        onResize() {
            if (window.innerWidth < 1263) this.$parent.$parent.isMobile = true;
            else this.$parent.$parent.isMobile = false;
        },
    }
}
</script>

<style scoped>
    a.router-link-active {text-decoration: none;}
    .v-app-bar.v-app-bar--fixed{
        z-index: 11 !important;
    }
    .v-toolbar__content{
        width: 100%;
    }
    .text-family{
        font-family: 'PoppinsRegular' !important;
    }
    
    .v-menu__content{
        overflow-y: hidden !important;
    }
    .text-pantone{
        color: #B08C55;
    }

    .v-toolbar__content{
        width: 100%;
    }

    @media only screen and (max-width: 770px) {
        .v-toolbar__content{
            width: 100%;
        }
    }
</style>
